import { createFileRoute } from "@tanstack/react-router";
import { OperationsScreen } from "./-operations/OperationsScreen";

export const Route = createFileRoute("/admin/operations")({
  staticData: { title: "Builds and deploys" },
  component: OperationsScreen,
});
